import { createAxiosClient } from "@ntg/component-library/utilities";
import { IOrchestrationQueryResult } from "../../declarations/IOrchestrationInstance";
import { useQuery } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface IOrchestrationFilters {
    createdFrom?: string;
    createdTo?: string;
    name?: string;
    pageSize?: number;
    status?: string;
    continuationToken?: string;
}

async function fetchOrchestrations(
    filters: IOrchestrationFilters,
): Promise<IOrchestrationQueryResult> {
    const params: Record<string, string | number> = {};

    if (filters.status) params.status = filters.status;
    if (filters.name) params.name = filters.name;
    if (filters.createdFrom) params.createdFrom = filters.createdFrom;
    if (filters.createdTo) params.createdTo = filters.createdTo;
    if (filters.pageSize) params.pageSize = filters.pageSize;
    if (filters.continuationToken) params.continuationToken = filters.continuationToken;

    const response = await apiClient.get<IOrchestrationQueryResult>(
        "/FunctionAppsStarter/GetOrchestrations",
        { params },
    );
    return response.data;
}

export function useOrchestrationInstances(filters: IOrchestrationFilters) {
    return useQuery({
        queryKey: ["orchestration-instances", filters],
        queryFn: () => fetchOrchestrations(filters),
        refetchInterval: 5000,
        staleTime: 0,
        refetchOnWindowFocus: false,
    });
}
